import { render, staticRenderFns } from "./portFee.vue?vue&type=template&id=456a8e5c&scoped=true&"
import script from "./portFee.vue?vue&type=script&lang=js&"
export * from "./portFee.vue?vue&type=script&lang=js&"
import style0 from "./portFee.vue?vue&type=style&index=0&id=456a8e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a8e5c",
  null
  
)

export default component.exports